import { useState, useEffect } from "react";
import useProcessos from "../../hooks/useProcessos";
import { api } from "../../api/api";
import ClienteAutocomplete from "../../components/financeiro/ClienteAutocomplete";

const FinanceiroLancamento = () => {
  const { processos, buscarPorCliente } = useProcessos(false);
  
  // 1. CORREÇÃO: useState retorna Array, não Objeto
  const [actionType, setActionType] = useState(null);

  const [form, setForm] = useState({
    clienteId: "",
    processoId: "",
    tipoProcesso: "",
    tipo: "avista",
    valorTotal: "",
    numeroParcelas: 1,
    dataInicio: "",
    descricao: ""
  });

  // 2. CORREÇÃO: Evita dependência instável que gera loop
  useEffect(() => {
    if (!form.clienteId) return;
    buscarPorCliente(form.clienteId);
  }, [form.clienteId, buscarPorCliente]); // Mantém apenas a dependência do ID do cliente

  // Função atualizada para download via Blob e Axios
  const baixarComprovante = async (id) => {
    try {
      const response = await api.get(`/parcelas/${id}/comprovante`, {
        responseType: "blob",
      });

      // Cria um Blob com o arquivo retornado da API
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `comprovante_${id}.pdf`);
      document.body.appendChild(link);
      link.click();

      // Limpeza de memória
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Erro ao baixar comprovante:", err);
      alert("Não foi possível baixar o comprovante.");
    }
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validação ANTES de iniciar o loading
    if (!form.clienteId) {
      alert("Selecione um cliente");
      return;
    }

    setActionType("salvar");

    try {
      // Normalização do payload
      const payload = {
        ...form,
        processoId:
          form.tipoProcesso === "administrativo"
            ? null
            : form.processoId
      };

      if (payload.tipoProcesso === "administrativo") {
        delete payload.processoId;
      }

      const res = await api.post("/financeiro", payload);
      const parcelas = res.data.parcelas || [];

      // 3. CORREÇÃO: Aguarda o tempo necessário sem quebrar o estado de loading
      if (form.tipo === "avista" && parcelas.length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 300));
        baixarComprovante(parcelas[0]._id);
      }

      alert("Lançamento realizado com sucesso!");

      setForm({
        clienteId: "",
        processoId: "",
        tipoProcesso: "judicial",
        tipo: "avista",
        valorTotal: "",
        numeroParcelas: 1,
        dataInicio: "",
        descricao: ""
      });

      await buscarPorCliente("");

    } catch (err) {
      console.error(err);
      alert("Erro ao lançar financeiro");
    } finally {
      setActionType(null);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h1>LANÇAMENTO FINANCEIRO</h1>
        <hr />

        <form onSubmit={handleSubmit}>
          <div className="form-grid">

            {/* CLIENTE */}
            <div className="form-group full-width">
              <label>Cliente</label>

              <ClienteAutocomplete
                onSelect={(cliente) => {
                  if (!cliente) {
                    setForm((prev) => ({
                      ...prev,
                      clienteId: "",
                      processoId: ""
                    }));
                    return;
                  }

                  setForm((prev) => ({
                    ...prev,
                    clienteId: cliente._id,
                    processoId: ""
                  }));
                }}
              />

              {form.clienteId && (
                <span style={{ fontSize: "12px", marginTop: "5px" }}>
                  Cliente selecionado
                </span>
              )}
            </div>

            {/* TIPO DE PROCESSO */}
            <div className="form-group">
              <label>Tipo de processo</label>

              <select
                className="input"
                value={form.tipoProcesso}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    tipoProcesso: e.target.value,
                    processoId: ""
                  }))
                }
              >
                <option value="">Selecione</option>
                <option value="judicial">Judicial</option>
                <option value="administrativo">Administrativo</option>
              </select>
            </div>

            {/* PROCESSO */}
            {form.tipoProcesso === "judicial" && (
              <div className="form-group">
                <label>Processo</label>

                <select
                  className="input"
                  value={form.processoId}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      processoId: e.target.value
                    }))
                  }
                >
                  <option value="">
                    {!form.clienteId
                      ? "Selecione um cliente primeiro"
                      : processos.length === 0
                        ? "Nenhum processo encontrado"
                        : "Selecione o processo"}
                  </option>

                  {processos.map((p) => (
                    <option key={p._id} value={p._id}>
                      {p.numeroProcesso}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* TIPO PAGAMENTO */}
            <div className="form-group">
              <label>Tipo de pagamento</label>

              <select
                className="input"
                value={form.tipo}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    tipo: e.target.value
                  }))
                }
              >
                <option value="avista">À vista</option>
                <option value="parcelado">Parcelado</option>
              </select>
            </div>

            {/* VALOR */}
            <div className="form-group">
              <label>Valor total</label>

              <input
                className="input"
                type="number"
                value={form.valorTotal}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    valorTotal: e.target.value
                  }))
                }
                required
              />
            </div>

            {/* PARCELAS */}
            {form.tipo === "parcelado" && (
              <>
                <div className="form-group">
                  <label>Número de parcelas</label>

                  <input
                    className="input"
                    type="number"
                    min="1"
                    value={form.numeroParcelas}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        numeroParcelas: e.target.value
                      }))
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Data de início</label>

                  <input
                    className="input"
                    type="date"
                    value={form.dataInicio}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        dataInicio: e.target.value
                      }))
                    }
                    required
                  />
                </div>
              </>
            )}

            {/* DESCRIÇÃO */}
            <div className="form-group full-width">
              <label>Descrição</label>

              <textarea
                className="input"
                value={form.descricao}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    descricao: e.target.value
                  }))
                }
              />
            </div>

          </div>

          <button 
            className="botao-primary" 
            type="submit"
            disabled={actionType !== null}
          >
            {actionType === "salvar" ? (
                <span className="spinner-loader"></span>
              ) : (
                "Salvar"
              )}
          </button>

        </form>
      </div>
    </div>
  );
};

export default FinanceiroLancamento;